// Iris — met à jour le prix affiché dans le bouton "Ajouter au panier"
// au changement de variante (via l'event variant:change émis par <variant-picker>).

(function () {
  // Prix au format de la boutique et dans la devise de la cliente (SEK, DKK...),
  // sans ",00" comme money_without_trailing_zeros côté Liquid.
  function money(cents) {
    var fmt = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) || '{{amount_with_comma_separator}} €';
    function sep(dec, th, ds) {
      var p = (cents / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      if (!p[1] || /^0+$/.test(p[1])) return p[0];
      return p[0] + ds + p[1];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m ? m[1] : '') {
      case 'amount': v = sep(2, ',', '.'); break;
      case 'amount_no_decimals': v = sep(0, ',', '.'); break;
      case 'amount_with_space_separator': v = sep(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = sep(0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = sep(2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': v = sep(2, "'", '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = sep(0, '.', ','); break;
      default: v = sep(2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function updatePriceForForm(formId, variant) {
    if (!formId || !variant) return;
    document
      .querySelectorAll('buy-buttons[form="' + formId + '"] [data-iris-atc-price]')
      .forEach(function (el) {
        el.textContent = money(variant.price);
      });
  }

  function init() {
    var forms = new Set();
    document.querySelectorAll('buy-buttons[form]').forEach(function (bb) {
      forms.add(bb.getAttribute('form'));
    });
    forms.forEach(function (formId) {
      var form = document.forms[formId];
      if (!form) return;
      form.addEventListener('variant:change', function (event) {
        var v = event.detail && event.detail.variant;
        updatePriceForForm(formId, v);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
